import React from "react";
import { connect } from "react-redux";
import {
  Accordion,
  Card,
  Row,
  Col,
  Table,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import { Trans } from "react-i18next";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import helpers from "util/helpers";
import { showModal } from "actions";
import i18n from "i18next";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.addLicense("ch-custom-attribution");
am4core.useTheme(am4themes_animated);

class ExamResultDetail extends React.Component {
  state = {
    visibleRows: [],
  };

  chartDiv = React.createRef();
  chart = null;
  chartCreated = false;

  componentDidMount() {
    this.renderChart(this.props.exam);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.exam !== this.props.exam && this.props.exam !== null) {
      this.renderChart(this.props.exam);
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  toggleRow = (id) => {
    if (this.state.visibleRows.some((z) => z === id))
      this.setState({
        visibleRows: this.state.visibleRows.filter((z) => z !== id),
      });
    else
      this.setState({
        visibleRows: [...this.state.visibleRows, id],
      });
  };

  renderReportLink = (result) => {
    if (result.reportLink === null || result.reportLink === "") return null;
    return (
      <a
        href={result.reportLink}
        rel="noopener noreferrer"
        target="_blank"
        className="btn btn-sm report-button"
      >
        <svg viewBox="0 107.603 612 562.472" fill="#fff">
          <path
            d="M176.333,326.768l-63.112,78.795l-42.267-42.266c-7.499-7.5-19.658-7.5-27.157,0c-7.5,7.499-7.5,19.658,0,27.157
																		l57.375,57.375c3.609,3.579,8.495,5.575,13.579,5.546h1.147c5.413-0.36,10.418-3.002,13.77-7.268l76.5-95.625
																		c7.25-7.681,6.901-19.785-0.78-27.036c-7.681-7.25-19.785-6.901-27.036,0.78C177.608,325.015,176.933,325.865,176.333,326.768
																		L176.333,326.768z"
          />
          <path
            d="M176.333,135.518l-63.112,78.795l-42.267-42.266c-7.499-7.5-19.658-7.5-27.157,0c-7.5,7.499-7.5,19.658,0,27.157
																		l57.375,57.375c3.609,3.58,8.495,5.576,13.579,5.546h1.147c5.413-0.36,10.418-3.001,13.77-7.268l76.5-95.625
																		c7.25-7.681,6.901-19.785-0.78-27.036s-19.785-6.901-27.036,0.78C177.608,133.765,176.933,134.615,176.333,135.518z"
          />
          <path
            d="M267.75,223.875h286.875c10.563,0,19.125-8.563,19.125-19.125s-8.563-19.125-19.125-19.125H267.75
																		c-10.563,0-19.125,8.563-19.125,19.125S257.188,223.875,267.75,223.875z"
          />
          <path
            d="M554.625,376.875H267.75c-10.563,0-19.125,8.563-19.125,19.125s8.563,19.125,19.125,19.125h286.875
																		c10.563,0,19.125-8.563,19.125-19.125S565.188,376.875,554.625,376.875z"
          />
          <path
            d="M554.625,568.125H267.75c-10.563,0-19.125,8.563-19.125,19.125s8.563,19.125,19.125,19.125h286.875
																		c10.563,0,19.125-8.563,19.125-19.125S565.188,568.125,554.625,568.125z"
          />
          <path
            d="M176.332,522.768l-63.112,78.795l-42.267-42.266c-7.499-7.5-19.658-7.5-27.157,0c-7.5,7.498-7.5,19.658,0,27.156
																		l57.375,57.376c3.609,3.579,8.495,5.575,13.579,5.546h1.147c5.413-0.36,10.419-3.002,13.771-7.268l76.5-95.625
																		c7.25-7.682,6.9-19.785-0.78-27.035s-19.785-6.901-27.036,0.779C177.607,521.016,176.933,521.865,176.332,522.768L176.332,522.768z"
          />
        </svg>
      </a>
    );
  };

  renderRecommendedTrainings = (result) => {
    return (
      <div>
        <span>
          {i18n
            .t("employee360_detailtext")
            .replace("___trainingname___", result.training.name)}
        </span>
        <ListGroup className="mt-4">
          {result.recommendedTrainings.map((training) => (
            <ListGroupItem key={training.id}>{training.name}</ListGroupItem>
          ))}
        </ListGroup>
      </div>
    );
  };

  handleDetailClick = (result) => {
    this.props.showModal({
      modalType: "recommendedTranings",
      modalTitle: (
        <span>
          <Trans>employee360_detailinfo</Trans>
        </span>
      ),
      modalContent: this.renderRecommendedTrainings(result),
      modalFooter: (
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-sm btn-redirect-trainings"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            <Trans>employee360_home</Trans>
          </button>
        </div>
      ),
      modalCustomClassName: "modal-lg ttModal",
    });
  };

  renderDetailLink = (result) => {
    if (result.success === true || result.recommendedTrainings.length === 0)
      return null;
    return (
      <button
        className="btn btn-sm"
        style={{ background: "#3497cb", color: "#fff" }}
        onClick={() => this.handleDetailClick(result)}
      >
        <span className="iconmford fo-icon-search"></span>
      </button>
    );
  };

  renderScoreChart = (score, success) => {
    if (score === null) return null;
    let color = success ? "green" : "red";
    return (
      <>
        <div
          id="statusCalendarChart_1"
          className="statusCalendarChart"
          data-percent={score}
        >
          <div>
            <div className="single-chart">
              <svg viewBox="-2 -2 40 40" className={`circular-chart ${color}`}>
                <path
                  className="circle-bg"
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <path
                  className="circle"
                  strokeDasharray={`${score}, 100`}
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <text x="18" y="22.35" className="percentage">
                  {score}
                </text>
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  };

  renderTabletModeDetail = (result) => {
    if (!this.state.visibleRows.some((z) => z === result.id)) return null;
    return (
      <tr>
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans>employee360_date</Trans>
                  </div>
                </td>
                <td>{helpers.renderDate(result.date)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    <Trans>employee360_score</Trans>
                  </div>
                </td>
                <td>{this.renderScoreChart(result.score, result.success)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans>employee360_detail</Trans>
                  </div>
                </td>
                <td>{this.renderDetailLink(result)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="4">
                <td>
                  <div className="tableTitle">
                    <Trans>employee360_report</Trans>
                  </div>
                </td>
                <td>{this.renderReportLink(result)}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  renderRow = (result) => {
    return (
      <React.Fragment key={result.id}>
        <DesktopBreakpoint>
          <tr>
            <td>
              <b>
                {result.number}.<Trans>employee360_exam</Trans>
              </b>
              <br />
              {result.examName}
            </td>
            <td>{helpers.renderDate(result.date)}</td>
            <td>{this.renderScoreChart(result.score, result.success)}</td>
            <td>{this.renderDetailLink(result)}</td>
            <td>{this.renderReportLink(result)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr onClick={() => this.toggleRow(result.id)}>
            <td>
              <b>
                {result.number}.<Trans>employee360_exam</Trans>
              </b>
              <br />
              {result.examName}
            </td>
          </tr>
          {this.renderTabletModeDetail(result)}
        </TabletBreakpoint>
      </React.Fragment>
    );
  };

  renderTable = (exam) => {
    return (
      <div>
        <Table
          className="table display responsive dataTable no-footer dtr-none collapsed"
          id="dataTablePersonal"
        >
          <thead>
            <tr>
              <th>
                <Trans>employee360_examname</Trans>
              </th>
              <DesktopBreakpoint>
                <th>
                  <Trans>employee360_date</Trans>
                </th>
                <th>
                  <Trans>employee360_score</Trans>
                </th>
                <th>
                  <Trans>employee360_detail</Trans>
                </th>
                <th>
                  <Trans>employee360_report</Trans>
                </th>
              </DesktopBreakpoint>
            </tr>
          </thead>
          <tbody>{exam.results.map((result) => this.renderRow(result))}</tbody>
        </Table>
      </div>
    );
  };

  limitControl = (val, success) => {
    // if (val === 0) {
    //   return am4core.color("#e42c3b");
    // } else if (val < 55) {
    //   return am4core.color("#e42c3b");
    // } else if (val < 85) {
    //   return am4core.color("#ff9f00");
    // } else {
    //   return am4core.color("#4cc790");
    // }
    //green / Red
    return success ? "#4cc790" : "#e42c3b";
  };

  getChartData = (exam) => {
    const data = exam.results.map((r) => {
      return {
        x: `${r.number} ${i18n.t("employee360_exam")}`,
        date: helpers.renderDate(r.date),
        value: r.score,
        color: this.limitControl(r.score, r.success),
      };
    });
    return data;
  };

  renderChart = (exam) => {
    am4core.useTheme(am4themes_animated);
    let chart = am4core.create(this.chartDiv.current, am4charts.XYChart);
    chart.data = this.getChartData(exam);
    chart.responsive.enabled = true;

    let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    let xAxis2 = chart.xAxes.push(new am4charts.CategoryAxis());
    let yAxis = chart.yAxes.push(new am4charts.ValueAxis());

    yAxis.dataFields.category = "value";
    yAxis.renderer.labels.template.fontSize = 12;
    yAxis.renderer.labels.template.fontWeight = "bold";

    xAxis.renderer.minGridDistance = 40;
    xAxis2.renderer.minGridDistance = 40;
    xAxis.dataFields.category = "x";
    xAxis2.dataFields.category = "date";
    xAxis.renderer.labels.template.fontSize = 12;
    xAxis.renderer.labels.template.fontWeight = "bold";
    xAxis.renderer.labels.template.dy = -25;
    xAxis2.renderer.labels.template.fontSize = 12;
    xAxis2.renderer.labels.template.dy = 25;

    let series1 = chart.series.push(new am4charts.LineSeries());
    series1.dataFields.valueY = "value";
    series1.dataFields.categoryX = "x";
    series1.dataFields.value = "value";
    series1.strokeWidth = 2;

    let circleBullet = series1.bullets.push(new am4charts.CircleBullet());
    circleBullet.circle.stroke = am4core.color("#fff");
    circleBullet.circle.strokeWidth = 2;
    circleBullet.circle.radius = 20;

    let labelBullet = series1.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.text = "{value}";
    circleBullet.propertyFields.fill = "color";

    xAxis.events.on("sizechanged", function (ev) {
      const axis = ev.target;
      const cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
      if (cellWidth < axis.renderer.labels.template.maxWidth) {
        axis.renderer.labels.template.fontSize = 6;
      } else {
        axis.renderer.labels.template.fontSize = 12;
      }
    });

    xAxis2.events.on("sizechanged", function (ev) {
      const axis = ev.target;
      const cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
      if (cellWidth < axis.renderer.labels.template.maxWidth) {
        axis.renderer.labels.template.fontSize = 6;
      } else {
        axis.renderer.labels.template.fontSize = 12;
      }
    });

    this.chart = chart;
  };

  render() {
    const { exam, defaultActive } = this.props;
    return (
      <Accordion defaultActiveKey={defaultActive} className="sssAccordion mb-4">
        <Card key={exam.examType.value}>
          <Card.Header>
            <Accordion.Toggle
              as="h2"
              className="mb-0"
              eventKey={exam.examType.value}
            >
              <button className="btn btn-link" type="button">
                {exam.examType.label}
              </button>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey={exam.examType.value}>
            <Card.Body>
              <Row>
                <Col xs="12" sm="12" md="6">
                  {this.renderTable(exam)}
                </Col>
                <Col xs="12" sm="12" md="6">
                  <div
                    ref={this.chartDiv}
                    id="sinavsonuclari_chart"
                    className="mt-4"
                    style={{ width: "100%", height: "350px" }}
                  ></div>
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, {
  showModal,
})(ExamResultDetail);
